module.exports = __webpack_public_path__ + "static/media/icon-arrow-up-light.e809f967.svg";